const axios = require('axios')
const nuxtConfig = require('~/nuxt.config').default

// axios.defaults.withCredentials = 'include'

export const state = () => ({
	token: null
})

export const getters = {

}

export const mutations = {
	storeToken (state, token) {
		state.token = token
	}
}

export const actions = {
	phoneVerify ({ commit }, data) {
		return new Promise((resolve, reject) => {

			// let form = new FormData()
			// for (let key in data) {
			// 	// skip loop if the property is from prototype
			// 	if (!data.hasOwnProperty(key)) continue

			// 	form.append(key, data[key] || '')
			// }

			axios.post(`${nuxtConfig.env.apiURL}/couponPhoneVerify`, data).then(res => {
				if (res.data && res.data.error === 0) {
					commit('storeToken', res.data.token)
					resolve(res.data)
				} else {
					commit('storeToken', null)
					reject({
						code: 'unknown',
						...res.data
					})
				}
			}).catch(e => {
				reject(e)
			})
		})
	},

	otpVerify ({ state }, data) {
		return new Promise((resolve, reject) => {

			// let form = new FormData()
			// for (let key in data) {
			// 	// skip loop if the property is from prototype
			// 	if (!data.hasOwnProperty(key)) continue

			// 	form.append(key, data[key] || '')
			// }

			axios.post(`${nuxtConfig.env.apiURL}/couponSubmitOTP`, {
				...data,
				token: state.token
			}).then(res => {
				if (res.data && res.data.error === 0) {
					resolve(res.data)
				} else {
					reject({
						code: 'unknown',
						...res.data
					})
				}
			}).catch(e => {
				reject(e)
			})
		})
	},

	submitRegister ({ commit, state }, data) {
		return new Promise((resolve, reject) => {

			// let form = new FormData()
			// for (let key in data) {
			// 	// skip loop if the property is from prototype
			// 	if (!data.hasOwnProperty(key)) continue

			// 	form.append(key, data[key] || '')
			// }

			axios.post(`${nuxtConfig.env.apiURL}/couponRegister`, {
				...data,
				token: state.token
			}).then((res) => {
				if (res.data && res.data.error === 0) {
					commit('storeToken', null)
					resolve(res.data)
				} else {
					reject({
						code: 'unknown',
						...res.data
					})
				}
			}).catch(e => {
				reject(e)
			})
		})
	}
}
